<template>
  <div>
    <button
      @click="generateReport"
      class="flex items-center px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 focus:outline-none"
    >
      <span class="mr-2 text-base font-semibold">{{ $t("common.print") }}</span>
      <svg
        v-if="!isPending"
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
        ></path>
      </svg>
      <svg
        v-else
        class="w-5 h-5 animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </button>
    <vue-html2pdf
      :show-layout="false"
      :preview-modal="false"
      pdf-content-width="660px"
      ref="html2Pdf"
      :manual-pagination="true"
      :html-to-pdf-options="{filename, margin: [15, 15, 15, 17], html2canvas: {scrollX: '0', scrollY: '0', scale: 2}}"
      @progress="onProgress($event)"
    >
      <section slot="pdf-content" class="w-full text-xs bg-white page-padding">
        <section class="pdf-item">
          <pdf-header />
          <div class="mt-3 text-2xl font-bold">
            {{ $t("main.matching") }}
          </div>
        </section>
        <pdf-base-product-listing
          v-for="(item, index) in results[0].use"
          :is-base-product="true"
          :apiData="item"
          :capacities="results[0].capacities"
          :title-label="results[0].label"
          :title-code="results[0].code"
          :key="index"
        />
        <pdf-base-product-listing
          v-for="item in otherProducts"
          :is-base-product="false"
          :apiData="item"
          :title-label="item.label"
          :key="item.label"
        />
        <pdf-footer />
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import PdfHeader from '@/components/print/PdfHeader';
import PdfFooter from '@/components/print/PdfFooter';
import PdfBaseProductListing from '@/components/print/PdfBaseProductListing.vue';
import VueHtml2pdf from 'vue-html2pdf';
import { snakeCase } from 'change-case';
import { mapState } from 'vuex';

export default {
  components: {
    VueHtml2pdf,
    PdfHeader,
    PdfFooter,
    PdfBaseProductListing
  },
  data: () => ({
    isPending: false
  }),
  methods: {
    async generateReport () {
      this.isPending = true;
      await this.$refs.html2Pdf.generatePdf();
    },
    onProgress (event) {
      this.isPending = event < 100;
    }
  },
  computed: {
    ...mapState({
      results: state => state.apiData.results,
      clientVehicle: state => state.apiData.clientVehicle
    }),
    otherProducts () {
      const resultsArr = Object.values(this.results);
      const otherProducts = resultsArr.slice(1);
      return otherProducts;
    },
    filename () {
      const name = `RAVENOL Oilguide - ${this.clientVehicle.type}`;
      return snakeCase(name);
    }
  }
};
</script>

<style scoped lang="postcss">
.page-padding {
  /* padding: 15mm 15mm 5mm 17mm; */
}
</style>
